import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
}

const ListIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 20;
  const color = props.color || 'black';
  return <Icon name={'list'} size={size} color={color} />;
};

export default React.memo(ListIcon);
